<template>
    <ProductsComponent />
  </template>
  
  <script>
  import ProductsComponent from '@/components/ProductsComponent.vue'
  
  export default {
    components: { ProductsComponent }
  }
  </script>
  